// libs
import React from 'react';

import { useTranslation } from '@lyearn/i18n';
// components
import { Button, Stack, Typography } from '@lyearn/ui';
import { Popover } from '@lyearn/ui';

// types
import { ScoreProps } from './types';

const Score = React.forwardRef<HTMLDivElement, ScoreProps>((props, ref) => {
  const { selected, value, onChange, disabled, className, repeatedSkillNudge, ...rest } = props;
  const { t } = useTranslation();

  return (
    <Popover open={repeatedSkillNudge.show} onOpenChange={repeatedSkillNudge.onOpen}>
      {({ open, onClose }) => (
        <>
          <Popover.Button>
            <Stack
              ref={ref}
              alignItems="center"
              className={className}
              data-value={value}
              justifyContent="center"
              onClick={disabled ? undefined : onChange}
              {...rest}>
              <Typography
                color={selected ? 'text-text-white' : 'text-text-secondary'}
                variant="body-short-02">
                {value}
              </Typography>
            </Stack>
          </Popover.Button>
          {open ? (
            <Popover.Content
              className="border-border rounded-12 ps-16 pe-12 pt-16 pb-12 !-ms-8"
              maxWidth={24}
              position="right">
              <Stack direction="col" gapY={20}>
                <Typography color="text-text-primary" variant="body-short-02">
                  {t('Skills:Review.MultipleSkillNudge')}
                </Typography>
                <Button
                  appearance="secondary"
                  className="w-min self-end"
                  shape="square"
                  size="x-small"
                  onClick={onClose}>
                  {t('Common:GotIt')}
                </Button>
              </Stack>
            </Popover.Content>
          ) : null}
        </>
      )}
    </Popover>
  );
});

export default React.memo(Score);
